import { createSvgIcon } from '@mui/material/utils';

const Variation = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="512"
    height="512"
    x="0"
    y="0"
    viewBox="0 0 68 68"
  >
    <path
      d="M48 6.828V16c0 2.667-4 2.667-4 0V6.828l-.586.586a2 2 0 0 1-2.828-2.828l4-4a2 2 0 0 1 2.828 0l4 4a2 2 0 0 1-2.828 2.828zm10 4.344V2a2 2 0 0 1 4 0v9.172l.586-.586a2 2 0 0 1 2.828 2.828l-4 4a2 2 0 0 1-2.828 0l-4-4a2 2 0 0 1 2.828-2.828zM42 64h3V28a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v36h5a2 2 0 0 1 0 4H2a2 2 0 0 1 0-4h5V50a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v14h3V41a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z"
      fill="#ffffff"
      opacity="1"
      data-original="#ffffff"
    ></path>
  </svg>,
  'Variation'
);

export default Variation;
